import { render } from "./Bookshelf.vue?vue&type=template&id=aea5d558&scoped=true"
import script from "./Bookshelf.vue?vue&type=script&lang=js"
export * from "./Bookshelf.vue?vue&type=script&lang=js"

import "./Bookshelf.vue?vue&type=style&index=0&id=aea5d558&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aea5d558"]])

export default __exports__